import type { TrackerMessage, TrackerMessageOverview } from '@racemap/sdk/schema/trackers';
import type { Immutable } from 'immer';

export const isMessageClosed = (
  message: Immutable<TrackerMessageOverview | TrackerMessage>,
): boolean => {
  return message.closeAfter.valueOf() < Date.now();
};
